<template>
  <v-dialog
    v-model="visible"
    max-width="520"
    persistent
  >
    <v-card class="unsaved-changes-card">
      <!-- Close button -->
      <v-btn
        icon
        class="close-btn"
        @click="close"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <!-- Content -->
      <v-card-text class="text-center pb-4 pt-8">
        <!-- Warning icon -->
        <div class="warning-icon-wrapper mb-4">
          <svg width="75" height="76" viewBox="0 0 75 76" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="75" height="76" rx="37.5" fill="#FFB443" fill-opacity="0.1"/>
            <path d="M37 43.0417C36.2483 43.0417 35.625 42.4183 35.625 41.6667V32.5C35.625 31.7483 36.2483 31.125 37 31.125C37.7517 31.125 38.375 31.7483 38.375 32.5V41.6667C38.375 42.4183 37.7517 43.0417 37 43.0417Z" fill="#FFB443"/>
            <path d="M37 48.9994C36.89 48.9994 36.7617 48.981 36.6334 48.9627C36.5234 48.9444 36.4134 48.9077 36.3034 48.8527C36.1934 48.816 36.0834 48.761 35.9734 48.6877C35.8817 48.6144 35.79 48.541 35.6984 48.4677C35.3684 48.1194 35.1667 47.6427 35.1667 47.166C35.1667 46.6894 35.3684 46.2127 35.6984 45.8644C35.79 45.791 35.8817 45.7177 35.9734 45.6444C36.0834 45.571 36.1934 45.516 36.3034 45.4794C36.4134 45.4244 36.5234 45.3877 36.6334 45.3694C36.8717 45.3144 37.1284 45.3144 37.3484 45.3694C37.4767 45.3877 37.5867 45.4244 37.6967 45.4794C37.8067 45.516 37.9167 45.571 38.0267 45.6444C38.1184 45.7177 38.21 45.791 38.3017 45.8644C38.6317 46.2127 38.8334 46.6894 38.8334 47.166C38.8334 47.6427 38.6317 48.1194 38.3017 48.4677C38.21 48.541 38.1184 48.6144 38.0267 48.6877C37.9167 48.761 37.8067 48.816 37.6967 48.8527C37.5867 48.9077 37.4767 48.9444 37.3484 48.9627C37.2384 48.981 37.11 48.9994 37 48.9994Z" fill="#FFB443"/>
            <path d="M48.11 56.6264H25.89C22.315 56.6264 19.5834 55.3247 18.19 52.978C16.815 50.6314 16.9984 47.6064 18.74 44.4714L29.85 24.488C31.6833 21.188 34.2134 19.373 37 19.373C39.7867 19.373 42.3167 21.188 44.15 24.488L55.26 44.4897C57.0017 47.6247 57.2033 50.6314 55.81 52.9964C54.4167 55.3247 51.685 56.6264 48.11 56.6264ZM37 22.123C35.2767 22.123 33.59 23.443 32.2517 25.8264L21.16 45.828C19.9133 48.0647 19.7117 50.118 20.5733 51.603C21.435 53.088 23.3417 53.8947 25.9083 53.8947H48.1283C50.695 53.8947 52.5833 53.088 53.4633 51.603C54.3433 50.118 54.1233 48.083 52.8767 45.828L41.7484 25.8264C40.41 23.443 38.7234 22.123 37 22.123Z" fill="#FFB443"/>
          </svg>

        </div>

        <!-- Title -->
        <h3 class="text-h6 mb-2" style="font-weight: 600; color: #19233A;">Unsaved Changes</h3>

        <!-- Message -->
        <p class="text-body-2 text--secondary">
          You have unsaved changes on this page. If you leave now, your changes will be lost. Do you want to save changes?
        </p>
      </v-card-text>

      <!-- Actions -->
      <v-card-actions class="justify-center pb-6">
        <v-btn
          outlined
          color="grey"
          class="mr-2 px-6"
          style="border-color:#2477F6 !important;color:#2477F6 !important;"
          @click="cancel"
        >
          CANCEL
        </v-btn>
        <v-btn
          color="primary"
          class="px-4"
          style="background:#2477F6 !important;"
          @click="saveAndContinue"
        >
          SAVE & CONTINUE
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'UnsavedChangesDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    cancel() {
      this.$emit('cancel');
    },
    saveAndContinue() {
      this.$emit('save-and-continue');
    }
  }
};
</script>

<style scoped>
.unsaved-changes-card {
  position: relative;
  border-radius: 8px !important;
}

.close-btn {
  position: absolute !important;
  right: 8px;
  top: 8px;
  z-index: 1;
}

.warning-icon-wrapper {
  display: inline-block;
}

.text-h6 {
  color: #333;
}

.text--secondary {
  color: #666 !important;
}

.v-btn--outlined {
  border-width: 1px !important;
}
</style>